module.exports = __webpack_public_path__ + "static/reversity_privacy_policy-ab4c5f9e708a665b9248a7115d81b0e9.pdf";